module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.fa27723.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/bootstrap/glyphicons-halflings-regular.woff
// module id = 861
// module chunks = 0